<popup-c class="bs-enabled no-content-padding" *ngIf="showApplyPolicyPopup"
		 head="Copy Policy" size="large"
		 subTitle="This tool allows you to copy policies from a chosen plan to multiple selected plans"
		 (closeCb)="showApplyPolicyPopup = false;">
	<div class="flex-column f-1-0 pt-2 gap-2" style="padding: 20px; overflow: auto;">
		<!--steps progress-->
		<div class="steps-container">
			<div class="step-tab"
				 [ngClass]="{'active' : installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectFromAdmin }">
				Select Source Plan
			</div>
			<div class="step-tab"
				 [ngClass]="{'active' : installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectAdmins }">
				Select Destination Plans
			</div>
			<div class="step-tab"
				 [ngClass]="{'active' : installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectPolicy }">
				Select policies
			</div>
			<div class="step-tab"
				 [ngClass]="{'active' : installPolicyData.step === dic.CONSTANTS.installPolicySteps.summary }">
				Summary & Execution
			</div>
		</div>

		<!--Steps content:-->

		<!--STEP: Select admins-->
		<div class="flex-column overflow-auto animated fadeIn f-1-0 gap-2 p-2 pt-3"
			 *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectFromAdmin">
			<span>Select a plan to copy policies from:</span>
			<div class="flex-column f-1-0 overflow-auto gap-2 p-2">
				<div class="position-relative f-1-0 flex-column overflow-auto">
					<trustifi-table-c
						class="trustifi-table f-1-0" style="z-index: 5;"
						[list]="fromAdmins"
						[headers]="[
							{text: 'Email', sortKey: 'email'},
							{text: 'Name', sortKey: 'name'},
						]"
						[cellsPrototype]="[
							  {html: 'adminCell'},
							  {textKey: 'name'},
						  ]"
						(searchFunction)="searchFromAdmin($event.searchTerm, $event.activeFilters)"
						(onAnyItemSelected)="fromAdminSelection($event.item)"
						[options]="{
							itemsNameSingular: 'admin',
							defaultSortKey: 'name',
							showRadioButtons: true,
						}"

					>
						<ng-template #customCells let-item let-cellId="cellId">
							<!--admin email cell-->
							<div *ngIf="cellId === 'adminCell'" class="h100">
								<div class="flxRow hSpace1" style="align-items: center;">
									<i class="fa" [ngClass]="item.isTemplate ? 'fa-clipboard-list' : 'fa-user-tie'"
									   [tooltip]="item.isTemplate ? 'Template plan' : null"></i>
									<span>{{item.email}}</span>
								</div>
							</div>
						</ng-template>
					</trustifi-table-c>
				</div>
			</div>
		</div>

		<!--STEP: Select admins-->
		<div class="flex-column overflow-auto animated fadeIn f-1-0 gap-2 p-2 pt-3"
			 *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectAdmins">
			<span>Select one or more plans that policies will be copied to:</span>
			<div class="flex-column f-1-0 overflow-auto gap-2 p-2">
				<label class="radio-container m-0" style="display: inline-block;">
					All plans
					<input type="radio" name="installPolicyAdmins"
						   [(ngModel)]="adminSelectionTypeSelection"
						   [value]="adminSelectionType.all"
						   [checked]="adminSelectionTypeSelection === adminSelectionType.all">
					<span class="checkmark"></span>
				</label>
				<label class="radio-container m-0" style="display: inline-block;">
					All managed plans
					<input type="radio" name="installPolicyAdmins"
						   [(ngModel)]="adminSelectionTypeSelection"
						   [value]="adminSelectionType.managed"
						   [checked]="adminSelectionTypeSelection === adminSelectionType.managed">
					<span class="checkmark"></span>
				</label>
				<div class="flex-row gap-1 align-items-center">
					<label class="radio-container m-0" style="display: block; width: fit-content;">
						Specific plans:
						<input type="radio" name="installPolicyAdmins"
							   [(ngModel)]="adminSelectionTypeSelection"
							   [value]="adminSelectionType.specific"
							   [checked]="adminSelectionTypeSelection === adminSelectionType.specific">
						<span class="checkmark"></span>
					</label>
					<span class="animated fadeIn" *ngIf="adminSelectionTypeSelection === adminSelectionType.specific">
                                    ({{_.filter(planAdmins, 'selected').length || '0'}} selected)
                                </span>
				</div>
				<div class="position-relative f-1-0 flex-column overflow-auto">
					<!--table overlay when disabled-->
					<div class="w-100 h-100" style="background-color: white; position: absolute; top: 0; left: 0; z-index: 20; opacity: 0.6;"
						 *ngIf="adminSelectionTypeSelection !== adminSelectionType.specific">
					</div>
					<trustifi-table-c
						class="trustifi-table f-1-0" style="z-index: 5;"
						[list]="planAdmins"
						[headers]="[
							{text: 'Email', sortKey: 'email'},
							{text: 'Name', sortKey: 'name'},
						]"
						[cellsPrototype]="[
							{html: 'adminCell'},
							{textKey: 'name'},
						]"
						(searchFunction)="searchToAdmin($event.searchTerm, $event.activeFilters)"
						[options]="{
							itemsNameSingular: 'admin',
							showRadioButtons: true,
							defaultSortKey: 'name',
						}"

					>
						<ng-template #customCells let-item let-cellId="cellId">
							<!--admin email cell-->
							<div *ngIf="cellId === 'adminCell'" class="h100">
								<div class="flxRow hSpace1" style="align-items: center;">
									<i class="fa" [ngClass]="item.isTemplate ? 'fa-clipboard-list' : 'fa-user-tie'"
									   [tooltip]="item.isTemplate ? 'Template plan' : null"></i>
									<span>{{item.email}}</span>
								</div>
							</div>
						</ng-template>
					</trustifi-table-c>
				</div>
			</div>
		</div>

		<!--STEP: Choose policies-->
		<div class="flxClmn f-1-0 gap-2 p-2 pt-3 animated fadeIn"
			 *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectPolicy">
			<div class="flxRow-between" style="align-items: baseline;">
				<span>Select policy components to copy</span>
				<div class="flex-row gap-3">
					<ng-container *ngIf="planPolicyTemplates?.length && !policiesTemplateInput">
						<app-dropdown-c style="width: 220px;"
										[enableSearch]="true"
										(onItemDelete)="deletePolicyInstallTemplate($event.item)"
										[items]="planPolicyTemplates"
										itemDisplayKey="name"
										(onItemClicked)="selectPolicyTemplate($event.item)"
										[text]="selectedPolicyTemplate?.name || 'Select policy template'"></app-dropdown-c>
						<div class="vertical-separator h-auto opacity-25"></div>
					</ng-container>
					<a class="blue-link flex-row gap-1 align-items-center animated fadeIn"
					   style="font-size: 14px; min-height: 30px;"
					   *ngIf="!policiesTemplateInput"
					   (click)="policiesTemplateInput = {name: selectedPolicyTemplate?.name || '', error: ''}">
						<i class="far fa-cog"></i>
						<span>Save as template</span>
					</a>
					<div class="flex-row align-items-cetner gap-1 animated fadeIn"
						 *ngIf="policiesTemplateInput">
						<input type="text" class="f-1-0" style="width: 170px;"
							   (keyup.enter)="savePolicyInstallTemplate();"
							   [appAutoFocus]="true"
							   [ngClass]="{'validation-error' : policiesTemplateInput.error}"
							   placeholder="Template name"
							   [(ngModel)]="policiesTemplateInput.name">
						<btn-c style="min-width: 30px;"
							   endIcon="zmdi zmdi-check"
							   [loading]="installPolicyInProcess"
							   (action)="savePolicyInstallTemplate();">
						</btn-c>
						<btn-c style="min-width: 30px;"
							   endIcon="zmdi zmdi-close" color="danger"
							   variant="text"
							   [isDisabled]="installPolicyInProcess"
							   (action)="policiesTemplateInput = null;">
						</btn-c>
					</div>
				</div>
			</div>
			<div class="flxClmn copy-policy-options p-2">
				<a class="blue-link justify-content-end align-self-end py-2" style="font-size: 14px;"
				   (click)="selectAllPolicies();">
					Select all
				</a>
				<div class="flex-row align-items-center border">
					<div class="flex-column gap-2 justify-content-center align-items-center bs-col-2">
						<i class="far fa-shield" style="font-size: 1rem;"></i>
						<span class="fw-bold text-center">Outbound<br/>Shield</span>
					</div>
					<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem 2rem; border-left: 1px solid lightgray;">
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.outbound.rules = !installPolicyData.policy.outbound.rules"
							 [ngClass]="{'active' : installPolicyData.policy.outbound.rules}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="outboundRules" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.outbound.rules"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Outbound Rules</span>
						</div>
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.outbound.policy = !installPolicyData.policy.outbound.policy"
							 [ngClass]="{'active' : installPolicyData.policy.outbound.policy}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="outboundPolicy" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.outbound.policy"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Outbound Policy</span>
						</div>
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.outbound.enforce_domain = !installPolicyData.policy.outbound.enforce_domain"
							 [ngClass]="{'active' : installPolicyData.policy.outbound.enforce_domain}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="enforce_domain" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.outbound.enforce_domain"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Enforce Shared Plan Domain</span>
						</div>
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.outbound.welcome_email = !installPolicyData.policy.outbound.welcome_email"
							 [ngClass]="{'active' : installPolicyData.policy.outbound.welcome_email}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="welcome_email" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.outbound.welcome_email"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Send Welcome Email To New Users</span>
						</div>
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications = !installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications"
							 [ngClass]="{'active' : installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="outbound_reviewers_quarantine_notifications" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Outbound quarantine notification recipients</span>
						</div>
					</div>
				</div>

				<div class="flex-row align-items-center" style="border: 1px solid lightgray;">
					<div class="flex-column gap-2 justify-content-center align-items-center bs-col-2"  style="">
						<i class="far fa-user-shield" style="font-size: 1rem;"></i>
						<span class="fw-bold" style="text-align: center;">Inbound<br/>Shield</span>
					</div>
					<div class="flex-column gap-3" style="padding: 1.5rem 2rem; border-left: 1px solid lightgray;">
						<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start">
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.rules = !installPolicyData.policy.inbound.rules"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.rules}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="tpRules" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.rules"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Threat Prevention Rules</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.inbound_email_rules =!installPolicyData.policy.inbound.inbound_email_rules"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.inbound_email_rules}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="inboundEmailRules" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.inbound_email_rules"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Inbound Email Rules</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.phishing_bypass =!installPolicyData.policy.inbound.phishing_bypass"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.phishing_bypass}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="phishing_bypass" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.phishing_bypass"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Phishing Simulation Bypass</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.url_rewrite =!installPolicyData.policy.inbound.url_rewrite"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.url_rewrite}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="url_rewrite" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.url_rewrite"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">On-click Link Scan</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.url_tracking =!installPolicyData.policy.inbound.url_tracking"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.url_tracking}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="url_tracking" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.url_tracking"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">URL Hunting</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.smart_banner =!installPolicyData.policy.inbound.smart_banner"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.smart_banner}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="smart_banner" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.smart_banner"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Smart Banners</span>
							</div>

							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.senders_whitelist = !installPolicyData.policy.inbound.senders_whitelist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.senders_whitelist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="senderAllowList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.senders_whitelist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Sender Allowlist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.senders_whitelist_advanced = !installPolicyData.policy.inbound.senders_whitelist_advanced"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.senders_whitelist_advanced}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="senders_whitelist_advanced" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.senders_whitelist_advanced"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Sender Allowlist Advanced Settings</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.personal_list_settings = !installPolicyData.policy.inbound.personal_list_settings"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.personal_list_settings}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="personal_list_settings" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.personal_list_settings"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Personal List Settings</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.senders_blacklist = !installPolicyData.policy.inbound.senders_blacklist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.senders_blacklist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="senderBlockList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.senders_blacklist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Sender Blocklist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.links_whitelist = !installPolicyData.policy.inbound.links_whitelist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.links_whitelist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="linksAllowList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.links_whitelist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;">Links Allowlist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.links_blacklist = !installPolicyData.policy.inbound.links_blacklist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.links_blacklist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="linksBlockList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.links_blacklist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Links Blocklist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.attachments_whitelist = !installPolicyData.policy.inbound.attachments_whitelist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.attachments_whitelist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="attachmentAllowList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.attachments_whitelist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Attachments Allowlist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.attachments_blacklist = !installPolicyData.policy.inbound.attachments_blacklist"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.attachments_blacklist}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="attachmentsBlockList" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.attachments_blacklist"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Attachments Blocklist</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.block_files_types = !installPolicyData.policy.inbound.block_files_types"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.block_files_types}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="blockFileTypes" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.block_files_types"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Block File Types</span>
							</div>
							<div class="policy-option gap-2"
								 (click)="installPolicyData.policy.inbound.block_files_types_extensions = !installPolicyData.policy.inbound.block_files_types_extensions"
								 [ngClass]="{'active' : installPolicyData.policy.inbound.block_files_types_extensions}"
								 style="width: 180px; cursor: pointer;">
								<div class="cover"></div>
								<input id="blockFileTypesExtensions" type="checkbox"
									   [(ngModel)]="installPolicyData.policy.inbound.block_files_types_extensions"
									   style="accent-color: white; width: 15px;"/>
								<span class="form-check-label" style="cursor: pointer;" >Uncommon File Extensions</span>
							</div>
						</div>
					</div>
				</div>

				<div class="flex-row align-items-center border">
					<div class="flex-column gap-2 justify-content-center align-items-center bs-col-2">
						<i class="far fa-lock" style="font-size: 1rem;"></i>
						<span class="fw-bold text-center">Domain<br/>Protection</span>
					</div>
					<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem 2rem; border-left: 1px solid lightgray;">
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.domainProtection.domain_impersonation_enabled = !installPolicyData.policy.domainProtection.domain_impersonation_enabled"
							 [ngClass]="{'active' : installPolicyData.policy.domainProtection.domain_impersonation_enabled}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="domain_impersonation_enabled" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.domainProtection.domain_impersonation_enabled"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Domain Impersonation Configuration</span>
						</div>
					</div>
				</div>

				<div class="flex-row align-items-center border">
					<div class="flex-column gap-2 justify-content-center align-items-center bs-col-2">
						<div style="margin-top: 6px; flex-shrink: 0; width: 16px; height: 16px; color: white; background: #000; mask-size: auto 16px; -webkit-mask-size: auto 16px; mask-repeat: no-repeat; -webkit-mask-repeat: no-repeat; mask-image: url('images/double-hook.svg');"></div>
						<span class="fw-bold text-center">Simulation <br/>Training</span>
					</div>
					<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem 2rem; border-left: 1px solid lightgray;">
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.threatSimulation.templates = !installPolicyData.policy.threatSimulation.templates"
							 [ngClass]="{'active' : installPolicyData.policy.threatSimulation.templates}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="templates" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.threatSimulation.templates"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Templates</span>
						</div>

						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.threatSimulation.materials = !installPolicyData.policy.threatSimulation.materials"
							 [ngClass]="{'active' : installPolicyData.policy.threatSimulation.materials}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="materials" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.threatSimulation.materials"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Materials</span>
						</div>
					</div>
				</div>

				<div class="flex-row align-items-center border">
					<div class="flex-column gap-2 justify-content-center align-items-center bs-col-2">
						<i class="far fa-user-secret" style="font-size: 1rem;"></i>
						<span class="fw-bold text-center">Account<br/>Takeover</span>
					</div>
					<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem 2rem; border-left: 1px solid lightgray;">
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.accountTakeover.incident_types = !installPolicyData.policy.accountTakeover.incident_types"
							 [ngClass]="{'active' : installPolicyData.policy.accountTakeover.incident_types}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="acpConfiguration" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.accountTakeover.incident_types"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Configuration</span>
						</div>
						<div class="policy-option gap-2"
							 (click)="installPolicyData.policy.accountTakeover.rules = !installPolicyData.policy.accountTakeover.rules"
							 [ngClass]="{'active' : installPolicyData.policy.accountTakeover.rules}"
							 style="width: 180px; cursor: pointer;">
							<div class="cover"></div>
							<input id="acpConfiguration" type="checkbox"
								   [(ngModel)]="installPolicyData.policy.accountTakeover.rules"
								   style="accent-color: white; width: 15px;"/>
							<span class="form-check-label" style="cursor: pointer;">Rules</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--STEP: Summary-->
		<div class="flxClmn f-1-0 animated fadeIn gap-3 p-2" *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.summary">
			<div class="list-group list-group-flush" style="padding: 1rem 4rem;">

				<div class="list-group-item flex-row align-items-center" style="min-height: 100px;">
					<div class="bs-col-2">
						<img style="width: 82px; filter: invert(.16) sepia(.8) hue-rotate(170deg) saturate(800%);" src="images/admin-list-icon.png">
					</div>
					<div class="bs-col-4">
						<span>Copy policy from plan:</span>
					</div>
					<div class="bs-col-5 offset-md-1">
						<span class="fw-bold">{{installPolicyData.fromAdmin}}</span>
					</div>
				</div>

				<div class="list-group-item flex-row align-items-center" style="min-height: 100px;">
					<div class="bs-col-2">
						<img style="width: 72px; filter: none;" src="images/triple-arrow-right.png">
					</div>
					<div class="bs-col-4">
						<span>Copy these policies:</span>
					</div>
					<div class="bs-col-5 offset-md-1">
						<div class="flex-column gap-3" style="max-height: 130px; overflow: auto;">
							<span *ngIf="installPolicyData.policy.outbound.rules"
								  style="color: var(--bs-primary);">
								<i class="far fa-check" style="font-size: 0.8em;"></i> Outbound Rules</span>
							<span *ngIf="installPolicyData.policy.outbound.policy"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Outbound Policy</span>

							<span *ngIf="installPolicyData.policy.outbound.enforce_domain"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Enforce Shared Plan Domain</span>
							<span *ngIf="installPolicyData.policy.outbound.welcome_email"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Send Welcome Email To New Users</span>
							<span *ngIf="installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Outbound quarantine notification recipients</span>

							<span *ngIf="installPolicyData.policy.inbound.rules"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Threat Prevention Rules</span>
							<span *ngIf="installPolicyData.policy.inbound.inbound_email_rules"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Inbound Email Rules</span>
							<span *ngIf="installPolicyData.policy.inbound.phishing_bypass"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Phishing Simulation Bypass</span>
							<span *ngIf="installPolicyData.policy.inbound.url_rewrite"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> On-click Link Scan</span>
							<span *ngIf="installPolicyData.policy.inbound.url_tracking"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> URL Hunting</span>
							<span *ngIf="installPolicyData.policy.inbound.smart_banner"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Smart Banner</span>

							<span *ngIf="installPolicyData.policy.inbound.personal_list_settings"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Personal List Settings</span>

							<span *ngIf="installPolicyData.policy.inbound.senders_whitelist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Sender Allowlist</span>
							<span *ngIf="installPolicyData.policy.inbound.senders_whitelist_advanced"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Sender Allowlist Advanced Settings</span>
							<span *ngIf="installPolicyData.policy.inbound.senders_blacklist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Sender Blocklist</span>
							<span *ngIf="installPolicyData.policy.inbound.links_whitelist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Links Allowlist</span>
							<span *ngIf="installPolicyData.policy.inbound.links_blacklist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Links Blocklist</span>
							<span *ngIf="installPolicyData.policy.inbound.attachments_whitelist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Attachments Allowlist</span>
							<span *ngIf="installPolicyData.policy.inbound.attachments_blacklist"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Attachments Blocklist</span>
							<span *ngIf="installPolicyData.policy.inbound.block_files_types"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Block File Types</span>
							<span *ngIf="installPolicyData.policy.inbound.block_files_types_extensions"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Uncommon File Extensions</span>
							<span *ngIf="installPolicyData.policy.domainProtection.domain_impersonation_enabled"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Domain Impersonation Configuration</span>
							<span *ngIf="installPolicyData.policy.threatSimulation.templates"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Threat Simulation Templates</span>
							<span *ngIf="installPolicyData.policy.threatSimulation.materials"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Threat Simulation Materials</span>
							<span *ngIf="installPolicyData.policy.accountTakeover.incident_types"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Account Takeover Configuration</span>
							<span *ngIf="installPolicyData.policy.accountTakeover.rules"
								  style="color: var(--bs-primary);">
                                            <i class="far fa-check" style="font-size: 0.8em;"></i> Account Takeover Rules</span>
						</div>
					</div>
				</div>
				<div class="list-group-item flex-row align-items-center" style="min-height: 100px;">
					<div class="bs-col-2">
						<img style="width: 82px; filter: none;" src="images/admin-list-icon.png">
					</div>
					<div class="bs-col-4">
						<span>Copy policies to plans:</span>
					</div>
					<div class="bs-col-5 offset-md-1">
						<span *ngIf="adminSelectionTypeSelection === adminSelectionType.all">All plans</span>
						<span *ngIf="adminSelectionTypeSelection === adminSelectionType.managed">All managed plans</span>
						<div class="flex-column gap-1" *ngIf="adminSelectionTypeSelection === adminSelectionType.specific"
							 style="max-height: 134px; overflow: auto;">
							<span *ngFor="let admin of installPolicyData.admins">{{admin}}</span>
						</div>
					</div>
				</div>

				<div class="list-group-item flex-row align-items-center" style="min-height: 100px;">
					<div class="bs-col-2">
						<i class="far fa-copy" style="font-size: 2rem; opacity: 0.6;"></i>
					</div>
					<div class="bs-col-4">
						<span>Copy mode:</span>
					</div>
					<div class="bs-col-5 offset-md-1 flex-column gap-2">
						<label class="radio-container m-0" style="display: inline-block;">
							Append (merge into existing)
							<input type="radio" name="installPolicyMode"
								   [(ngModel)]="installPolicyData.appendMode"
								   [value]="true">
							<span class="checkmark"></span>
						</label>
						<label class="radio-container m-0" style="display: inline-block;">
							Replace (override existing)
							<input type="radio" name="installPolicyMode"
								   [(ngModel)]="installPolicyData.appendMode"
								   [value]="false">
							<span class="checkmark"></span>
						</label>
					</div>
				</div>
			</div>
		</div>

		<!--error message and buttons-->
		<div class="flex-row justify-content-between align-items-end mb-3 px-4 w-100">
			<div>
				 <span class="f-1-0 pe-3 text-danger" *ngIf="installPolicyData.error && installPolicyData.step !== dic.CONSTANTS.installPolicySteps.summary">
					{{installPolicyData.error}}
				</span>
				<div class="flex-row align-items-center bg-warning border border-warning gap-3 p-2 animated fadeIn" style="--bs-bg-opacity: .15;"
					 *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.summary">
					<i class="far fa-exclamation-circle text-warning" style="font-size: 1rem;"></i>
					<div class="flex-column">
						<ng-container *ngIf="!installPolicyData.appendMode">
							<div class="flex-row gap-1 align-items-center">
								<i class="fa fa-circle" style="font-size:0.3em;"></i>
								<span>These new rules will override the existing rules in the selected sections.</span>
							</div>
							<div class="flex-row gap-1 align-items-center">
								<i class="fa fa-circle" style="font-size:0.3em;"></i>
								<span>Items that have been overwritten cannot be restored.</span>
							</div>
						</ng-container>
						<ng-container *ngIf="installPolicyData.appendMode">
							<div class="flex-row gap-1 align-items-center">
								<i class="fa fa-circle" style="font-size:0.3em;"></i>
								<span>List-based fields (e.g., rules or lists) are merged with the target.</span>
							</div>
							<div class="flex-row gap-1 align-items-center">
								<i class="fa fa-circle" style="font-size:0.3em;"></i>
								<span>Single-value settings (e.g., policy options or toggles) replace the existing values in the target.</span>
							</div>
							<div class="flex-row gap-1 align-items-center">
								<i class="fa fa-circle" style="font-size:0.3em;"></i>
								<span>Items that have been overwritten cannot be restored.</span>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div class="flex-row gap-2">
				<btn-c class="popup-action-btn"
					   *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.selectFromAdmin"
					   variant="outlined" (action)="showApplyPolicyPopup = false;">
					Cancel
				</btn-c>
				<btn-c class="popup-action-btn"
					   *ngIf="installPolicyData.step !== dic.CONSTANTS.installPolicySteps.selectFromAdmin"
					   variant="outlined" (action)="installPolicyBackStep();">
					Back
				</btn-c>
				<btn-c class="popup-action-btn"
					   *ngIf="installPolicyData.step !== dic.CONSTANTS.installPolicySteps.summary"
					   (action)="chooseInstallPolicyAdmins(); installPolicyNextStep();">
					Next
				</btn-c>
				<btn-c class="popup-action-btn"
					   *ngIf="installPolicyData.step === dic.CONSTANTS.installPolicySteps.summary"
					   [isDisabled]="installPolicyInProcess"
					   (action)="installPolicyExecute();">
					Apply changes
				</btn-c>
			</div>
		</div>
	</div>
</popup-c>


